export default {
    200: {
        
    },
    403: {
        'ACL_FORBIDDEN': 'Na provedení této akce nemáte dostatečné oprávnění',
        'NO_MESSAGE': 'Akce zakázána',
    },
    409: {
        'LINKED_PROPERTIES_EXISTS': 'Existují nějaké navázané vlastností - nejdříve je vymažte',
    },
    400: {
        'INVALID_USER_PASS': 'Neplatné uživatelské jméno nebo heslo',
        'NO_PASS': 'Nebylo zadáno heslo',
        'ACC_DISABLED': 'Účet nemá povoleno se přihlásit',
    },
}
